import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { absoluteUrl } from "../lib/seo";
import { fastFaqs, siteFaqs } from "../content/discoveryContent";

const allFaqs = [...siteFaqs, ...fastFaqs];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: allFaqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: absoluteUrl("/"),
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "FAQ",
      item: absoluteUrl("/faq"),
    },
  ],
};

const FaqPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Seo
        title="FAQ | Drishti Technologies and FAST"
        description="Frequently asked questions about Drishti Technologies, FAST accounting workflow software, product scope and how to engage the team."
        path="/faq"
        keywords={[
          "Drishti Technologies FAQ",
          "FAST software FAQ",
          "accounting workflow software FAQ",
          "custom software development FAQ",
        ]}
        jsonLd={[faqSchema, breadcrumbSchema]}
      />
      <Header />

      <main className="pt-20">
        <section className="py-20 bg-gradient-to-b from-black via-zinc-950 to-black">
          <div className="max-w-screen-xl mx-auto px-6 lg:px-12">
            <p className="text-xs tracking-[0.35em] uppercase text-red-500 mb-4">
              FAQ
            </p>
            <h1 className="text-4xl lg:text-6xl font-bold mb-6">
              Frequently asked questions about <span className="text-red-600">Drishti Technologies</span> and FAST
            </h1>
            <p className="text-xl text-white/70 leading-relaxed max-w-3xl">
              This page is written to answer common buyer and evaluator questions in direct language. It also gives search engines and AI systems a clearer factual map of the company and its accounting workflow product.
            </p>
          </div>
        </section>

        <section className="py-24 bg-gradient-to-b from-zinc-950 via-black to-zinc-950">
          <div className="max-w-screen-xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="space-y-5">
                <h2 className="text-3xl font-semibold mb-2">About Drishti Technologies</h2>
                {siteFaqs.map((faq) => (
                  <article key={faq.question} className="border border-white/15 bg-white/[0.04] p-6">
                    <h3 className="text-xl font-semibold mb-3">{faq.question}</h3>
                    <p className="text-white/70 leading-relaxed">{faq.answer}</p>
                  </article>
                ))}
              </div>

              <div className="space-y-5">
                <h2 className="text-3xl font-semibold mb-2">About FAST</h2>
                {fastFaqs.map((faq) => (
                  <article key={faq.question} className="border border-white/15 bg-white/[0.04] p-6">
                    <h3 className="text-xl font-semibold mb-3">{faq.question}</h3>
                    <p className="text-white/70 leading-relaxed">{faq.answer}</p>
                  </article>
                ))}
              </div>
            </div>

            <div className="mt-16 border border-red-600/30 bg-red-600/[0.08] p-8 lg:p-10">
              <h2 className="text-3xl font-semibold mb-4">Next steps</h2>
              <p className="text-white/75 leading-relaxed mb-6 max-w-3xl">
                If your interest is specifically around accounting workflow software, open the FAST product page first. If you want to discuss implementation, process fit or a broader software engagement, contact Drishti Technologies directly.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="/products/fast"
                  className="inline-flex items-center justify-center bg-red-600 text-black px-8 py-4 text-sm font-medium tracking-[0.18em] uppercase transition-all duration-400 hover:bg-white hover:text-black"
                  style={{ borderRadius: "0px" }}
                >
                  Open FAST Page
                </a>
                <a
                  href="/#contact"
                  className="inline-flex items-center justify-center border border-white/30 text-white px-8 py-4 text-sm font-medium tracking-[0.18em] uppercase transition-all duration-400 hover:border-red-500 hover:text-red-400"
                  style={{ borderRadius: "0px" }}
                >
                  Contact Drishti Tech
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FaqPage;
